//====== WR data 02/09/2026
// Motivo da alteração: pedido do usuário, com print — Country do parceiro estrangeiro só resolvia
// certo pra 2 países hardcoded (China/Eslováquia), definidos "no olho" a partir de uma
// investigação pontual. O usuário passou uma planilha oficial (export da tabela de Países do
// próprio SAP, entidade Countries) com os 241 países cadastrados neste tenant (Código = sigla que
// o campo Country do SAP espera, Name = nome em português, igual ao que costuma vir na tag xPais
// da NF-e). Convertida aqui pra um array estático — evita bater no SAP a cada resolução de país
// (isso já acontece à parte, ver garantirEstadoExVinculado em smartflowSapWrite.js, que confirma/
// cria a combinação Estado="EX"+Country certo sob demanda).
// O que faz: PAISES_SAP é a tabela completa (código SAP + nome oficial); resolverCodigoPaisSap
// (usado em SmartFlowImporterForm.js) faz o match do nome vindo do XML contra esta tabela.
// ======
export const PAISES_SAP = [
  { code: "AF", name: "Afeganistão" },
  { code: "AL", name: "Albânia" },
  { code: "DE", name: "Alemanha" },
  { code: "DZ", name: "Algéria" },
  { code: "VI", name: "American Virg.Islnd" },
  { code: "AD", name: "Andorra." },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AG", name: "Antigua e Barbuda" },
  { code: "AN", name: "Antilhas Holandesas" },
  { code: "AQ", name: "Antártida" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armênia" },
  { code: "AW", name: "Aruba" },
  { code: "SA", name: "Arábia Saudita" },
  { code: "AU", name: "Austrália" },
  { code: "AZ", name: "Azerbaijão" },
  { code: "BS", name: "Bahamas" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BH", name: "Barein" },
  { code: "BY", name: "Belarus" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BO", name: "Bolívia" },
  { code: "BQ", name: "Bonaire" },
  { code: "BW", name: "Botsuana" },
  { code: "BR", name: "Brasil" },
  { code: "IO", name: "Brit.Ind.Oc.Ter" },
  { code: "VG", name: "British Virg. Islnd" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgária" },
  { code: "BF", name: "Burkina Fasso" },
  { code: "BI", name: "Burundi" },
  { code: "BT", name: "Butão" },
  { code: "BE", name: "Bélgica" },
  { code: "BA", name: "Bósnia-Herzegóvina" },
  { code: "CV", name: "Cabo Verde" },
  { code: "CM", name: "Camarões" },
  { code: "KH", name: "Camboja" },
  { code: "CA", name: "Canadá" },
  { code: "QA", name: "Catar" },
  { code: "KZ", name: "Cazaquistão" },
  { code: "TD", name: "Chade" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CY", name: "Chipre" },
  { code: "VA", name: "Cidade do Vaticano" },
  { code: "SG", name: "Cingapura" },
  { code: "CO", name: "Colômbia" },
  { code: "KM", name: "Comores" },
  { code: "CG", name: "Congo" },
  { code: "KP", name: "Coréia do Norte" },
  { code: "KR", name: "Coréia do Sul" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "Costa do Marfim" },
  { code: "HR", name: "Croácia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Curaçao" },
  { code: "DK", name: "Dinamarca" },
  { code: "DJ", name: "Djibuti" },
  { code: "DM", name: "Dominica" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egito" },
  { code: "SV", name: "El Salvador" },
  { code: "AE", name: "Emirados Árabes Unidos" },
  { code: "ER", name: "Eritréia" },
  { code: "SK", name: "Eslováquia" },
  { code: "SI", name: "Eslovênia" },
  { code: "ES", name: "Espanha" },
  { code: "US", name: "Estados Unidos" },
  { code: "EE", name: "Estônia" },
  { code: "ET", name: "Etiópia" },
  { code: "FJ", name: "Fiji" },
  { code: "PH", name: "Filipinas" },
  { code: "FI", name: "Finlândia" },
  { code: "FR", name: "França" },
  { code: "TF", name: "French S.Territ" },
  { code: "GA", name: "Gabão" },
  { code: "GH", name: "Gana" },
  { code: "GE", name: "Georgia" },
  { code: "GI", name: "Gibraltar" },
  { code: "GD", name: "Granada" },
  { code: "GL", name: "Groenlândia" },
  { code: "EL", name: "Grécia" },
  { code: "GP", name: "Guadalupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GY", name: "Guiana" },
  { code: "GF", name: "Guiana Francesa" },
  { code: "GN", name: "Guiné" },
  { code: "GQ", name: "Guiné Equatorial" },
  { code: "GW", name: "Guiné-Bissau" },
  { code: "GM", name: "Gâmbia" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard/McDnld Islnds" },
  { code: "NL", name: "Holanda" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong (China)" },
  { code: "HU", name: "Hungria" },
  { code: "CK", name: "Ihas Cook" },
  { code: "NF", name: "Ilha Norfolk" },
  { code: "BV", name: "Ilhas Bouvet" },
  { code: "KY", name: "Ilhas Cayman" },
  { code: "CX", name: "Ilhas Christmas" },
  { code: "CC", name: "Ilhas Coco" },
  { code: "FO", name: "Ilhas Faroe" },
  { code: "FK", name: "Ilhas Malvinas" },
  { code: "MH", name: "Ilhas Marshall" },
  { code: "MP", name: "Ilhas N. Mariana" },
  { code: "NU", name: "Ilhas Niue" },
  { code: "PN", name: "Ilhas Pitcairn" },
  { code: "SB", name: "Ilhas Salomão" },
  { code: "GS", name: "Ilhas Sandwich do Sul" },
  { code: "TK", name: "Ilhas Tokelau" },
  { code: "ID", name: "Indonésia" },
  { code: "IQ", name: "Iraque" },
  { code: "IE", name: "Irlanda" },
  { code: "IR", name: "Irã" },
  { code: "IS", name: "Islândia" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Itália" },
  { code: "YU", name: "Iugoslávia" },
  { code: "YE", name: "Iêmen" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japão" },
  { code: "JO", name: "Jordânia" },
  { code: "KI", name: "Kiribati" },
  { code: "KW", name: "Kuwait" },
  { code: "LA", name: "Laos" },
  { code: "LS", name: "Lesoto" },
  { code: "LR", name: "Libéria" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lituânia" },
  { code: "LU", name: "Luxemburgo" },
  { code: "LV", name: "Látvia" },
  { code: "LB", name: "Líbano" },
  { code: "LY", name: "Líbia" },
  { code: "MO", name: "Macau (China)" },
  { code: "MK", name: "Macedônia" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malavi" },
  { code: "MV", name: "Maldivas" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MY", name: "Malásia" },
  { code: "MA", name: "Marrocos" },
  { code: "MQ", name: "Martinica" },
  { code: "MR", name: "Mauritânia" },
  { code: "MU", name: "Maurício" },
  { code: "YT", name: "Mayotte" },
  { code: "MM", name: "Mianmar" },
  { code: "FM", name: "Micronésia" },
  { code: "UM", name: "Minor Outl.Ins." },
  { code: "MD", name: "Moldávia" },
  { code: "MN", name: "Mongólia" },
  { code: "MS", name: "Montserrat" },
  { code: "MZ", name: "Moçambique" },
  { code: "MX", name: "México" },
  { code: "MC", name: "Mônaco" },
  { code: "NA", name: "Namíbia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NI", name: "Nicarágua" },
  { code: "NG", name: "Nigéria" },
  { code: "NO", name: "Noruega" },
  { code: "NC", name: "Nova Caledônia" },
  { code: "NZ", name: "Nova Zelândia" },
  { code: "NE", name: "Níger" },
  { code: "OM", name: "Omã" },
  { code: "PW", name: "Palau" },
  { code: "PA", name: "Panamá" },
  { code: "PG", name: "Papua Nova Guiné" },
  { code: "PK", name: "Paquistão" },
  { code: "PY", name: "Paraguai" },
  { code: "PE", name: "Peru" },
  { code: "PF", name: "Polinésia Francesa" },
  { code: "PL", name: "Polônia" },
  { code: "PR", name: "Porto Rico" },
  { code: "PT", name: "Portugal" },
  { code: "KG", name: "Quirguistão" },
  { code: "KE", name: "Quênia" },
  { code: "GB", name: "Reino Unido" },
  { code: "CF", name: "República Centro-Africana" },
  { code: "CZ", name: "República Checa" },
  { code: "CD", name: "República Democrática do Congo" },
  { code: "DO", name: "República Dominicana" },
  { code: "RE", name: "Reunião" },
  { code: "RO", name: "Romênia" },
  { code: "RW", name: "Ruanda" },
  { code: "RU", name: "Rússia" },
  { code: "EH", name: "Saara Ocidental" },
  { code: "AS", name: "Samoa Americana" },
  { code: "WS", name: "Samoa Ocidental" },
  { code: "SH", name: "Santa Helena" },
  { code: "LC", name: "Santa Lucia" },
  { code: "SN", name: "Senegal" },
  { code: "SL", name: "Serra Leoa" },
  { code: "SC", name: "Seychelles" },
  { code: "SX", name: "Sint Maarten" },
  { code: "SO", name: "Somália" },
  { code: "LK", name: "Sri Lanka" },
  { code: "PM", name: "St.Pier" },
  { code: "SZ", name: "Suazilândia" },
  { code: "SD", name: "Sudão" },
  { code: "CH", name: "Suiça" },
  { code: "SR", name: "Suriname" },
  { code: "SE", name: "Suécia" },
  { code: "SJ", name: "Svalbard" },
  { code: "KN", name: "São Cristóvão e Nevis" },
  { code: "SM", name: "São Marinho" },
  { code: "ST", name: "São Tomé e Príncipe" },
  { code: "VC", name: "São Vicente" },
  { code: "SY", name: "Síria" },
  { code: "TH", name: "Tailândia" },
  { code: "TW", name: "Taiwan (China)" },
  { code: "TJ", name: "Tajiquistão" },
  { code: "TZ", name: "Tanzânia" },
  { code: "TP", name: "Timor Leste" },
  { code: "TG", name: "Togo" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidade e Tobago" },
  { code: "TN", name: "Tunísia" },
  { code: "TM", name: "Turcomenistão" },
  { code: "TC", name: "Turksh Caicosin" },
  { code: "TR", name: "Turquia" },
  { code: "TV", name: "Tuvalu" },
  { code: "UA", name: "Ucrânia" },
  { code: "UG", name: "Uganda" },
  { code: "UY", name: "Uruguai" },
  { code: "UZ", name: "Usbequistão" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnã" },
  { code: "WF", name: "Wallis e Futuna" },
  { code: "ZW", name: "Zimbábue" },
  { code: "ZM", name: "Zâmbia" },
  { code: "ZA", name: "África do Sul" },
  { code: "AT", name: "Áustria" },
  { code: "IN", name: "Índia" },
];

//====== WR data 02/09/2026
// Motivo da alteração: mesma alteração acima — resolve o nome do país (como vem em endereco.pais,
// tag xPais da NF-e) pra sigla de 2 letras que o campo Country do SAP espera. Normaliza (maiúsculas,
// sem acento) os dois lados e casa por CONTAINS (não igualdade exata) — a NF-e às vezes traz o
// nome oficial completo com texto extra (ex. "CHINA (REPUBLICA POPULAR DA CHINA)"), então uma
// comparação exata falharia; substring casa nos dois sentidos (nome da tabela contido no nome do
// XML, ou vice-versa) pra cobrir nomes abreviados também.
// @param {string|null} nomePais como vem em endereco.pais (tag xPais da NF-e)
// @return {string|null} sigla ISO de 2 letras, ou null quando não reconhecido/ausente
// ======
export function resolverCodigoPaisSap(nomePais, normalizarTexto) {
  const normalizado = normalizarTexto(nomePais);
  if (!normalizado) return null;

  const encontrado = PAISES_SAP.find((pais) => {
    const nomeTabela = normalizarTexto(pais.name);
    return normalizado.includes(nomeTabela) || nomeTabela.includes(normalizado);
  });

  return encontrado?.code || null;
}
